export default __webpack_public_path__ + "static/media/wolf.95bf7a3c.png";